import { Component, Inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { SupprimerPropriete } from '../../../propriete/propriete.state';
import { GtmService } from '../../services/gtm.service';
import { GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES, GTM_PUSH_CATEGORY } from '../../modeles/variables';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-supprimer-propriete',
  templateUrl: './dialog-supprimer-propriete.component.html',
  styleUrls: ['./dialog-supprimer-propriete.component.scss'],
  standalone: false
})
export class DialogSupprimerProprieteComponent {
  constructor(
    private readonly _store: Store,
    private readonly _gtm: GtmService,
    public dialogRef: MatDialogRef<DialogSupprimerProprieteComponent>,
    @Inject(MAT_DIALOG_DATA)
    private readonly data: { id: string }
  ) {}

  close() {
    this.dialogRef.close();
  }

  delete() {
    this._store
      .dispatch(new SupprimerPropriete(this.data.id))
      .toPromise()
      .then(() => {
        this._gtm.pushEvent({
          event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
          category: GTM_PUSH_CATEGORY,
          label: 'paiement',
          action: 'supprimer propriete',
          value: 0,
          nonInteraction: false
        });

        this.close();
      });
  }
}
